export const UPDATE_CAB_FAQ_DATA          : string = "UPDATE_CAB_FAQ_DATA"
export const UPDATE_CABS_CONFIG_DATA      : string = "UPDATE_CABS_CONFIG_DATA"
export const UPDATE_SOURCE                : string = "UPDATE_SOURCE"
export const UPDATE_DESTINATION           : string = "UPDATE_DESTINATION"
export const UPDATE_PREVIOUS_SOURCE       : string = "UPDATE_PREVIOUS_SOURCE"
export const UPDATE_PREVIOUS_DESTINATION  : string = "UPDATE_PREVIOUS_DESTINATION"
export const UPDATE_UNIFICATION_FLOW      : string = "UPDATE_UNIFICATION_FLOW"